import { Box, Flex, Text, Image } from '@chakra-ui/react';
import { useLayoutEffect } from 'react';

import emptyData from 'assets/empty_data_icon.png';
import { font, fontSize, radius, text as textToken } from 'styles/revampTokens';

/**
 * Light-theme empty state for BuilderModeRevamp's input panel.
 * Classic BuilderMode keeps its own EmptyData (white text via Container) —
 * do not share that component here or the copy goes invisible on white.
 */
const EmptyData = () => {
  useLayoutEffect(() => {
    document.title = 'Blox';
  }, []);

  return (
    <Flex
      h='100%'
      w='100%'
      direction='column'
      align='center'
      justify='start'
      pt={12}
      px={4}
      color={textToken.primary}
    >
      <Box
        bg='#E8F1FF'
        borderRadius={radius.surface}
        p={6}
        mb={4}
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <Image src={emptyData} w='12rem' h='12rem' objectFit='contain' alt='' />
      </Box>

      <Flex direction='column' justify='center' align='center' gap={1}>
        <Text
          width='220px'
          fontFamily={font.body}
          fontWeight={500}
          fontSize={fontSize.body}
          lineHeight='20px'
          textAlign='center'
          color={textToken.primary}
        >
          Select an ‘Input’ indicator
        </Text>
        <Text
          width='220px'
          fontFamily={font.body}
          fontSize={fontSize.body}
          lineHeight='20px'
          textAlign='center'
          color={textToken.secondary}
        >
          to update the input values
        </Text>
      </Flex>
    </Flex>
  );
};

export default EmptyData;
